// @license Copyright (c) 2016 Copyright Holder All Rights Reserved.
(function () {
	"use strict";

	/*
	URL Transform Directive
	*/

	angular.module("swurveys.maker")
		.directive("urlDataLink", Handler)

	function Handler() {
		return {
			require: 'ngModel',
			link: function (scope, element, attrs, ngModelController) {
				ngModelController.$parsers.push(function (data) {
					//convert data from view format to model format
					// In model we want the url:(), for exporting, we want
					// data += "-- V 2 M";
					if(!data)
						return "";

					data = "url(" + data + ")";

					return data; //converted
				});

				ngModelController.$formatters.push(function (data) {
					//convert data from model format to view format
					// In view we want just the link
					// data += "-- M 2 V";
					if(!data)
						return "";

					// console.log(attrs.ngSrc);
					data = data.substring(data.lastIndexOf("(") + 1, data.lastIndexOf(")"));

					// console.log(data);
					return data; //converted
				});
			}
		}
	}
}());
